import React from 'react';
import DetailField from "../../common/detail-field";
import {Col, Row} from "react-bootstrap";

const OutletDetails = ({ outlet: { id, customer_number } }) => (
  <div className="container-fluid">
    <Col md={4}>
      <Row>
        <DetailField label="Outlet ID" lg={4}>{id}</DetailField>
        <DetailField label="Customer Number" lg={4}>{customer_number}</DetailField>
      </Row>
    </Col>
  </div>
);

export default OutletDetails;


// WEBPACK FOOTER //
// ./src/components/admin/outlet-reward-allocation-view/outlet-details.jsx